export class SubstitutionConditionDto {
    condition: number;
    value: number;
}